const files = {
  DOC: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  DOCX: 'application/msword',
  PDF: 'application/pdf',
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  PNG: 'image/png',
  MP3: 'audio/mp3',
  MP4: 'video/mp4',
  MP4_EXT: '.mp4',
  RTF: 'text/rtf',
  AVI: 'video/avi',
  MPG: 'video/mpeg',
};

export default files;
